module.exports = __webpack_public_path__ + "static/media/12_tn.efb50b78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/12_tn.jpg
// module id = 226
// module chunks = 0